import "jquery";
import * as ko from "knockout";
import { CropActiveYearViewModel } from "../ViewModels/CropActiveYearViewModel";
import {CropActiveYear } from "../Models/Crops/CropActiveYear";
import { CropsApi } from "../apis/CropsApi";
import "footable-npm";

export class ActiveCrops {
    activeCropsViewModel: CropActiveYearViewModel<CropActiveYear>;
    $viewModelAnchor: JQuery;
    cropsApi: CropsApi;

    constructor() {
        this.cropsApi = CropsApi.getInstance();
        this.activeCropsViewModel = new CropActiveYearViewModel<CropActiveYear>();
        this.$viewModelAnchor = $('#dashboard-crop');

        //Binds the viewmodel to the template
        if (this.$viewModelAnchor[0]) {
            ko.applyBindings(this.activeCropsViewModel, this.$viewModelAnchor[0]);
        }
    }
    init(): void {
        this.cropsApi.getActiveCrops().then((res) => {
            this.activeCropsViewModel.allActiveCrops(res);
            ($('.toBeFoo') as any).footable();

            this.activeCropsViewModel.isLoading(false);

        });
    }
}